import Utils from 'core/utilities/Utils.js'
import {
    EVENT_NAME,
    LANDING_PAGE
} from 'core/constants/googleAnalyticEvents'

export default {
    beforeCreate () {
        this.$store.state.userLocationPromise
            .then(location => {
                if (location && location.subdivision_code === 'QC' && !this.$store.state.hasShownQuebecUserModal) {
                    this.showQuebecModal('ip')
                }
            })
    },
    methods: {
        showQuebecModal (type) {
            this.$router.replace({
                query: Utils.updateQueryParams(this.$route.query, { modal: 'quebec-user' })
            })

            if (type === 'ip') {
                this.$googleTagManager.pushEvent(EVENT_NAME, LANDING_PAGE.QUEBEC_SERVICE_MODAL_IP_BLOCK)
            }
            if (type === 'checkout') {
                this.$googleTagManager.pushEvent(EVENT_NAME, LANDING_PAGE.QUEBEC_SERVICE_MODAL_CHECKOUT_BLOCK)
            }

            this.$store.commit('setHasShownQuebecUserModal', true)
        },
        showQuebecModalCheckout () {
            this.$googleTagManager.pushEvent(EVENT_NAME, LANDING_PAGE.QUEBEC_SERVICE_MODAL_CHECKOUT_BLOCK)
            this.$router.replace({
                query: Utils.updateQueryParams(this.$route.query, { modal: 'quebec-user-checkout' })
            })
        }
    }
}
